<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary">
          <div style="margin-top: 5px">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab" href="#projectHistory"><b>{{ $t("project_history.title") }}</b></a>
              </li>
              <li>
                <a data-toggle="tab" href="#emailHistory"><b>{{ $t("project_history.emailHistory") }}</b></a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="projectHistory" class="tab-pane fade in active">
                <project-history />
              </div>
              <div id="emailHistory" class="tab-pane fade">
                <mail-history-agent />
              </div>
            </div>
          </div>
        </div>
      </row>
    </div>
  </div>
</template>

<script>
// import utils from "@/lib/utils";
import MailHistoryAgent from "../Mailbox/ManagementMailHistoryAgent";
import ProjectHistory from "./ProjectHistory";

export default {
  name: "HistoryTabs",
  components: {
    MailHistoryAgent,
    ProjectHistory
  }
};
</script>
<style lang="scss" scoped>
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/HistoryTabs.vue